import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'found';
import withAuth from '../App/Authenticate';
import { Accordion, Button, Container, Icon, Item, Grid, Segment } from 'semantic-ui-react';
import MobileHeader from '../App/MobileHeader';
import { Analytics, AvailabilityChecker } from '../Modules';
import { FloatingLabelInput as Input } from '../Elements';
import Formsy from 'formsy-react';
import styles from './Leads.scss';
import RecaptchaSettings from './RecaptchaSettings';

const KioskComponent = class Kiosk extends React.Component {

  static propTypes = {
    toggleSidebar: PropTypes.func,
    sidebarOpen: PropTypes.bool,
    relay: PropTypes.object.isRequired,
    viewer: PropTypes.object,
    router: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props);
    this.onAccordionClick = this.onAccordionClick.bind(this);
    this.textFieldChange = this.textFieldChange.bind(this);
    this.state = {
      title: 'Contact Us',
      activeIndex: 0
    };
  }

  componentDidMount() {
    Analytics.trackEvent('viewed-lead-kiosk');
  }

  onAccordionClick(e, titleProps) {
    const { index } = titleProps;
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;
    this.setState({ activeIndex: newIndex });
  }

  textFieldChange(e) {
    const newValue = {};
    newValue[e.target.name] = e.target.value;
    this.setState(Object.assign(this.state, newValue));
  }

  render() {
    const { relay, router, sidebarOpen, toggleSidebar, viewer } = this.props;
    const { activeIndex, title } = this.state;
    return (
      <Container>
        <Segment style={{ marginTop: '2em' }}>
          <MobileHeader router={router} viewer={viewer}>
            <div className='menu'>
              <Item as='a' className={sidebarOpen ? 'active ' : ''} onClick={toggleSidebar}>
                <Icon name='sidebar' />
              </Item>
            </div>
            <div className='right menu'>
              <AvailabilityChecker
                viewer={viewer}
                mobile
              />
              <Item as='a' onClick={router.push.bind(null, '/search')}>
                <Icon name='search' />
              </Item>
            </div>
          </MobileHeader>
          <Grid padded stackable>
            <Grid.Row columns='equal'>
              <Grid.Column>
                <h1>Bridal Show Kiosk</h1>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={16}>
                <p>
                  The Cloverbook live kiosk allows you to easily collect leads at
                  bridal shows and other events. It&apos;s the easiest way to get events
                  into Cloverbook and onto your calendar. Once a user submits the form,
                  it will automatically reset so the next user can add her
                  event information.
                </p>
                <Accordion styled fluid>
                  <Accordion.Title
                    index={0}
                    active={activeIndex === 0}
                    onClick={this.onAccordionClick}
                  >
                    <Icon name='dropdown' />
                    Settings
                  </Accordion.Title>
                  <Accordion.Content active={activeIndex === 0}>
                    <Grid padded relaxed stackable>
                      <Grid.Row>
                        <Grid.Column width={5} className={styles.settingsLabels}>
                          <p>
                            <strong>Title</strong>
                          </p>
                          <p className={styles.helperText}>
                            <em>
                              Customize the title of your form
                            </em>
                          </p>
                        </Grid.Column>
                        <Grid.Column width={11}>
                          <Formsy.Form className='ui form'>
                            <Input
                              label='Title'
                              type='text'
                              name='title'
                              value={title}
                              onChange={this.textFieldChange}
                            />
                          </Formsy.Form>
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  </Accordion.Content>
                  <Accordion.Title
                    index={1}
                    active={activeIndex === 1}
                    onClick={this.onAccordionClick}
                  >
                    <Icon name='dropdown' />
                    reCAPTCHA Spam Protection
                  </Accordion.Title>
                  <Accordion.Content active={activeIndex === 1}>
                    <RecaptchaSettings
                      viewer={viewer}
                      relay={relay}
                    />
                  </Accordion.Content>
                </Accordion>
                <a href={`${process.env.BASE_URL}/embed_widgets/${viewer.embed_token}?bridal_show=true${title !== '' ? `&title=${encodeURIComponent(title)}` : ''}`}>
                  <br />
                  <Button primary content='Go to Kiosk Mode' />
                </a>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Segment>
      </Container>
    );
  }
};

export default withRouter(withAuth(KioskComponent));



// WEBPACK FOOTER //
// ./webpack/components/Leads/KioskComponent.js